import { PropsWithChildren, useEffect, useState } from 'react';

import { debounce } from '../../utils/debounce';
import { MediaWidthContext } from './MediaContext';

const DEFAULT_DESKTOP_WIDTH = 1270;

export function MediaWidthProvider({ children }: PropsWithChildren) {
  const [mediaWidth, setMediaWidth] = useState<number>(DEFAULT_DESKTOP_WIDTH);

  useEffect(() => {
    const handleResize = debounce(() => setMediaWidth(window.innerWidth), 100);
    handleResize();

    // Todo: Переделать под хук useLayoutType()
    window.addEventListener('resize', handleResize);
    return (): void => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <MediaWidthContext.Provider value={mediaWidth}>
      {children}
    </MediaWidthContext.Provider>
  );
}
